
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueuePlotsArgs } from "@/shared/Executions/models/QueuePlotsArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";
import { InjectableService } from "@/shared/services/InjectableService";
import { AxiosResponse } from "axios";



export interface IPlotsApiService {
    processPlots: (userId: string, tenantId: string, args: QueuePlotsArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
}


export class PlotsApiService extends InjectableService implements IPlotsApiService {

    static readonly injectableKey = 'IPlotsApiService';

    get injectableKey() {
        return (this.constructor as typeof PlotsApiService).injectableKey;
    }

    constructor(private readonly _executionApiService: IExecutionApiService) {
        super()
    }

    public async processPlots(userId: string, tenantId: string, args: QueuePlotsArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

        const qeueueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, plotArgs: args });

        return await this._executionApiService.queueExecution(qeueueExecutionArgs);
    }


}

